const adminRoles = new Set(["admin", "superAdmin"])

const joinParts = parts => parts.filter(Boolean).join(" - ")

const getClubName = eventDetails =>
  eventDetails?.club?.clubName || eventDetails?.club?.name || "Club"

export const getAnnouncementSourceLabel = (announcement = {}, eventDetails) => {
  const source = announcement?.authorship?.source
  const actorName = announcement?.authorship?.actorName || announcement?.createdBy

  if (source === "SPORTYA") {
    return joinParts(["Sportya Admin", actorName])
  }

  if (source === "CLUB") {
    return joinParts(["Club", getClubName(eventDetails), actorName])
  }

  if (adminRoles.has(announcement?.createdByRole)) {
    return joinParts(["Sportya Admin", announcement?.createdBy])
  }

  if (announcement?.createdByRole || announcement?.createdBy) {
    return joinParts(["Club", getClubName(eventDetails), announcement?.createdBy])
  }

  return "Unknown source"
}

const timestamp = value => {
  const time = value ? new Date(value).getTime() : 0
  return Number.isNaN(time) ? 0 : time
}

export const sortAnnouncementsForDisplay = announcements =>
  [...(announcements || [])].sort((a, b) => {
    const aPinned = Boolean(a?.pinned)
    const bPinned = Boolean(b?.pinned)

    if (aPinned !== bPinned) {
      return aPinned ? -1 : 1
    }

    return timestamp(b?.createdAt) - timestamp(a?.createdAt)
  })
